/* GG · Scroll reveal (CLAUDE.md §1.6)
   Adds .is-visible to .gg-reveal elements as they enter the viewport,
   staggered per group. Fail-safe: if IntersectionObserver is missing or
   reduced-motion is set, everything is revealed immediately.

   Wichtig: .gg-reveal startet in gg-base.css mit opacity: 0. Alles, was diese
   Klasse traegt — Hero, Produktkarten, Section-Koepfe — ist also unsichtbar,
   bis DIESES Skript die Klasse setzt. Daraus folgen drei Regeln, die hier
   bewusst umgesetzt sind:

   1. NICHT auf DOMContentLoaded warten. Das Skript laeuft mit defer, die DOM
      ist bei der Ausfuehrung also fertig geparst. Der frueher hier stehende
      DOMContentLoaded-Listener wartete zusaetzlich auf ALLE anderen
      defer-Skripte (Dawn + App-Embeds). Auf der Startseite wurde
      DOMContentLoaded mobil erst bei 5143 ms erreicht — so lange blieben 18
      Elemente auf opacity 0, und die Seite sah leer aus.
   2. Harter Rueckfall nach FALLBACK_MS. Wenn der Observer aus irgendeinem
      Grund nicht liefert, wird trotzdem alles sichtbar. Inhalt darf nie an
      einem Effekt haengen.
   3. Nachtriggern bei pageshow und visibilitychange. In einem Hintergrundtab
      und beim Zurueck aus dem bfcache stellt der Browser keine Frames zu,
      und IntersectionObserver-Callbacks bleiben aus — die Seite wird erst
      beim ersten Scrollen sichtbar. Genau das war auf dem iPhone zu sehen. */
(function () {
  'use strict';

  var FALLBACK_MS = 1500;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function pending() {
    return Array.prototype.slice.call(document.querySelectorAll('.gg-reveal:not(.is-visible)'));
  }

  function revealAll() {
    pending().forEach(function (el) { el.classList.add('is-visible'); });
    if (observer) { observer.disconnect(); observer = null; }
  }

  function observe(els) {
    if (!els.length) return;
    els.forEach(function (el) { observer.observe(el); });
  }

  function init() {
    var els = pending();
    if (!els.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    observer = new IntersectionObserver(function (entries, obs) {
      // Stagger the ones revealing in the same batch.
      var i = 0;
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        setTimeout(function () { el.classList.add('is-visible'); }, i * 60);
        i++;
        obs.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    observe(els);

    // (2) Inhalt darf nie dauerhaft unsichtbar bleiben.
    setTimeout(revealAll, FALLBACK_MS);

    // (3) Hintergrundtab / bfcache: beim Sichtbarwerden neu beobachten.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) revealAll();
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible' && observer) observe(pending());
    });
  }

  // (1) defer => die DOM steht bereits; nur im Notfall auf DOMContentLoaded warten.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
